export default __webpack_public_path__ + "static/media/female_avatar.35f94501.svg";